export default "__VITE_ASSET__D0ic$dOu__"